module.exports = __webpack_public_path__ + "img/map.bd392e09.svg";